import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { style: { "background-color": "white" } };
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalWindow',
    props: {
        index: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const dragging = ref(false);
        const position = ref({ x: 0, y: 0 });
        const dragStart = (event) => {
            dragging.value = true;
            window.addEventListener("mouseup", dragEnd);
        };
        const dragEnd = (event) => {
            dragging.value = false;
            window.removeEventListener("mouseup", dragEnd);
        };
        // マウスの位置を取得
        const mouseMoveHandler = (event) => {
            if (dragging.value) {
                position.value.x += event.movementX;
                position.value.y += event.movementY;
            }
        };
        // mousemoveイベントの管理
        onMounted(() => {
            window.addEventListener("mousemove", mouseMoveHandler);
            // 初期位置は画面の中央
            position.value.x = window.innerWidth / 2 + window.scrollX - 200;
            position.value.y = window.innerHeight / 2 + window.scrollY - 200;
        });
        onBeforeUnmount(() => {
            window.removeEventListener("mousemove", mouseMoveHandler);
        });
        // 非表示の処理関連
        const emits = __emit;
        const closePopup = () => {
            emits("close");
        };
        // スタイル（表示位置の指定）
        const styleObject = computed(() => {
            return {
                top: `${position.value.y}px`,
                left: `${position.value.x}px`,
                "min-width": "300px",
                "z-index": props.index ? 2000 + props.index : 2000,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref: "popupElement",
                style: _normalizeStyle(styleObject.value),
                class: "popup-window"
            }, [
                _createElementVNode("div", {
                    class: "draggable-header",
                    onMousedown: _withModifiers(dragStart, ["stop"]),
                    onMouseup: _withModifiers(dragEnd, ["stop"])
                }, [
                    _createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "header")
                    ]),
                    _createElementVNode("button", {
                        onClick: closePopup,
                        class: "close-button"
                    }, "X")
                ], 32),
                _createElementVNode("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 4));
        };
    }
});
